import React from 'react';

export const Filter = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 8L20.5 8"
      stroke="#101828"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M4.5 16L14.5 16"
      stroke="#101828"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <ellipse
      cx="7.5"
      cy="8"
      rx="3"
      ry="3"
      transform="rotate(90 7.5 8)"
      stroke="#101828"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <ellipse
      cx="17.5"
      cy="16"
      rx="3"
      ry="3"
      transform="rotate(90 17.5 16)"
      stroke="#101828"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
